<script>
  import {getContext, onMount} from 'svelte';
  import {envUtil} from '@/helper/env';
  import {isLogin$} from '@/store/user';
  import Page from '@/modules/components/Page.svelte';
  import Header from '@/modules/header/Header.svelte';
  import Footer from '@/modules/footer/Footer.svelte';
  import {IMAGES} from './images.js';
  import {loadUserReferralType$} from './streams';
  import Banner from './components/Banner.svelte';
  import Steps from './components/Steps.svelte';
  import lang from './ReferralEntryPage.lang';
  import {loadReferralConfig$, newReferralConfig$} from '@/modules/referral-friends/streams';

  const LG = getContext('LG');
  const isApp = envUtil.isApp;

  $: configInfo = $newReferralConfig$;
  $: $isLogin$ && loadUserReferralType$.next();

  onMount(() => {
    loadReferralConfig$.next();
  });
</script>

<style>
  .referral-entry {
    padding-bottom: 40px;
    width: 100%;
    min-width: 1200px;
    background: #F2F6FB;
  }
  .bg-img > img{
    width: inherit;
    height: inherit;
  }
  .bg-img-h5 {
    display: none;
  }
  .bg-img-h5 > img {
    width: inherit;
    height: inherit;
  }
  @media screen and (max-width: 640px) {
    .referral-entry {
      padding-bottom: 0;
      min-width: auto;
    }
    .bg-img{
      display: none;
    }
    .bg-img-h5 {
      display: block;
      margin: 16px auto 0 auto;
    }
  }
</style>

<svelte:head>
  <title>{LG(lang.Title)}</title>
  <meta name="description" content={LG(lang.Description)} />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:site" content="@Phemex_official" />
  <meta name="twitter:title" content={LG(lang.Title)} />
  <meta name="twitter:image" content={IMAGES.SHARE} />
  <meta name="og:title" content={LG(lang.OGTitle)} />
  <meta name="og:description" content={LG(lang.OGDescription)} />
  <meta name="og:image" content={IMAGES.SHARE} />
</svelte:head>

<Page>
  {#if !isApp}
    <div class="dc h5">
      <Header />
    </div>
  {/if}
  <div class="referral-entry">
    <Banner innerMinHeight={265} title={LG(lang.BannerTitle,{Rewards: `<span style="color: #33d43e">${'$'+configInfo.inviteeRewards}</span>`})} desc={LG(lang.BannerDesc)}>
      <div slot='banner-img'>
        <span class='db bg-img tr' style='width: 324px;height: 265px;font-size: 0;'><img alt="Banner" class="" src="https://static.phemex.com/pubimg/3acaed02196f6c3723d4dd9123294380f3763d7c7f91c327aced6e9a8ccb33b2.png" height={265} /></span>
        <span class='db bg-img-h5 tc' style='width: 360px; height: 296px;font-size: 0;'><img alt="Banner" class="" src="https://static.phemex.com/pubimg/3acaed02196f6c3723d4dd9123294380f3763d7c7f91c327aced6e9a8ccb33b2.png" height={296} /></span>
      </div>
    </Banner>
    <Steps limitDay={30} inviteeRewards={configInfo.inviteeRewards || 0}/>
  </div>
  {#if !isApp}
    <div class="dc h5">
      <Footer />
    </div>
  {/if}
</Page>
